export default "__VITE_ASSET__CDExOFgE__"